import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[autoGrow]',
  standalone: false,
})
export class AutoGrowDirective implements AfterViewInit {

  // format when model changes via hydration
  @HostListener('ngModelChange', ['$event'])
  ngModelChange(value: number | string): void {
    if (this.element.nativeElement !== document.activeElement) {
      this.adjust();
    }
  }

  constructor(public element: ElementRef) {
  }

  protected adjust(): void {
      let nativeElement = this.element.nativeElement;
      nativeElement.style.overflow = 'hidden';
      nativeElement.style.height = 'auto';
      nativeElement.style.height = nativeElement.scrollHeight + "px";
  }

  ngAfterViewInit() {
    if (document.activeElement !== this.element.nativeElement) {
      this.adjust();
    }
  }
}
